import * as React from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ErrorPage } from 'pages/Error404';
import { LOCAL_STORAGE_TENANT_ID_KEY } from 'constants/locale-storage';
import { CustomerSupportRoutes } from '@leagueplatform/cse-customer-support';
import { CSAuthSignOut } from 'components/auth/cs-auth-sign-out.component';
import { CSAuthSignIn } from 'components/auth/cs-auth-sign-in.component';
import { LeagueProvider } from '@leagueplatform/core';
import { CSAuthSessionContainer } from 'components/auth/cs-auth-container.component';
import { getTenantSpecificConfig } from 'utils/get-tenant-specific-config';

const ProtectedRoutes = () => (
  <CSAuthSessionContainer>
    <Routes>
      <Route path="/" element={<Navigate replace to="/customer-support" />} />
      <Route path="/customer-support/*" element={<CustomerSupportRoutes />} />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  </CSAuthSessionContainer>
);

function AppRoutes() {
  const [tenantId] = useLocalStorage(LOCAL_STORAGE_TENANT_ID_KEY, '');

  const config = React.useMemo(
    () => getTenantSpecificConfig(tenantId),
    [tenantId],
  );

  return (
    <LeagueProvider config={config}>
      <Routes>
        <Route path="/start-login" element={<CSAuthSignIn />} />
        <Route path="/sign-out" element={<CSAuthSignOut />} />
        <Route path="/*" element={<ProtectedRoutes />} />
      </Routes>
    </LeagueProvider>
  );
}

export default AppRoutes;
